import React from "react";
import PrivateDBView from 'components/tire/view';
import Errors from 'components/error404';

export function TireRoutes() {
    return [
        {
            path: '',
            element: (<PrivateDBView />),
            errorElement: <Errors />,
        },
        {
            path: 'details/:id',
            element: (<PrivateDBView />),
            errorElement: <Errors />,
            //children: ProjectDetailsRoutes()
        },
    ]
}

export default TireRoutes;